import { useQuery } from "@tanstack/react-query";
import { getUserPendingMethods } from "api/booking.api";
import { getTeacherDetailsById } from "api/teacher.api.ts";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { PrevButton } from "ui/base/Button/EmblaButtons";
import { fonts, mediaSizes, pageContainerStyles } from "ui/theme";
import { userRoute } from "../user.routes";
import { DatesList } from "./sections/DatesList";
import { SelectedDates } from "./sections/SelectedDates";
import ScrollToTop from "ui/base/ScrollToTop/ScrollToTop";

export const ShowMoreDates = () => {
    const { class_id } = useParams();
    const navigate = useNavigate();

    const { data, isLoading, isFetching } = useQuery({
        queryKey: ["getTeacherDetailsById", class_id],
        queryFn: () => getTeacherDetailsById({ id: class_id }),
        enabled: !!class_id,
    });

    const classDetail = data?.data;

    useQuery({
        queryKey: ["getUserPendingMethods", classDetail?.teacher?.id],
        queryFn: () => getUserPendingMethods(classDetail?.teacher?.id),
        enabled: !!classDetail?.teacher?.id,
        onSuccess: (data) => {
            data.data && navigate(userRoute.classDetail + class_id);
        },
    });

    return (
        <>
        <Container>
            <Header>
                <PrevButton onClick={() => navigate(-1)} />
                <p>Select Dates</p>
            </Header>
            <ContentWrapper>
                <DatesList classDetail={classDetail} />
                <SelectedDates classDetail={classDetail} isLoading={isLoading || isFetching} />
            </ContentWrapper>
        </Container>
        </>
    );
};

const Container = styled.div`
    ${pageContainerStyles}
    font-family: var(--font-secondary);
    padding-bottom: 3rem;
    padding-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
 
    min-height: var(--page-height);
    @media (width >= ${mediaSizes.lg}) {
        padding-top: 40px;
    }
`;

const Header = styled.header`
    display: flex;
    align-items: center;
    gap: 1rem;
    height: fit-content;

    & p {
        font-size: ${fonts.sizes.big};
        font-weight: 600;

        @media (width >= ${mediaSizes.md}) {
            font-size: ${fonts.sizes.h4};
        }
        @media (width >= ${mediaSizes.lg}) {
            font-size: ${fonts.sizes["h3.4"]};
        }
    }
`;

const ContentWrapper = styled.div`
    display: grid;
    height: 100%;
    gap: 2rem;
    width: 100%;
    @media (width >= ${mediaSizes.md}) {
        grid-template-columns: 1fr 1fr;
        padding-block: 1rem;
        gap: 1rem;
    }
    @media (width >= ${mediaSizes.lg}) {
        padding-block: 2rem;
        gap: 2rem;
        margin-inline: auto;
        width: 90%;
    }
`;

